import * as yup from 'yup'

export class VehicleParkingSpaceDto {
  parkingSpace?: string = undefined
}

export const vehicleParkingSpaceValidationSchema = yup.object({
  parkingSpace: yup
    .string()
    .max(200, 'Parking Space cannot be more than 200 characters.')
    .required('Parking Space is required.')
})
